import text from './text.json'
import {useDispatch, useSelector} from 'react-redux'
import {setShowLoader, updatePassword} from '../../stores/customer-settings'
import Footer from '../../components/layouts/footer'
import {PageSubTitle, PageTitle, ResponsivePageTitle} from '../../components/core/title'
import {Formik} from 'formik'
import {passwordErrors} from '../../utils/validation'
import {useCallback, useState} from 'react'
import Input from '../../components/core/input'
import {SimpleBlueButton} from '../../components/core/button'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import Forms from '../../utils/forms'
import classNames from 'classnames'
import {trimStringValues} from '../../utils/text'

const ChangePassword = () => {
    const showLoader = useSelector(state => state.customer_settings.showLoader)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const dispatch = useDispatch()
    const [active, setActive] = useState(null)
    const [formErrors, setFormErrors] = useState({
        previous_password: [],
        proposed_password: [],
        confirm_new_password: []
    })

    const names = {
        previous_password: 'previous_password',
        proposed_password: 'proposed_password',
        confirm_new_password: 'confirm_new_password'
    }
    const initialFormValues = {
        previous_password: '',
        proposed_password: ''
    }
    const updateCustomerPassword = (values, {setFieldError}) => {
        const data = {
            previous_password: values.previous_password,
            proposed_password: values.proposed_password
        }
        dispatch(updatePassword(trimStringValues(data), setFieldError))
        dispatch(setShowLoader(true))
    }

    const handleInfo = (index, state) => {
        state ? setActive(index) : setActive(null)
    }

    const checkIsValid = (values, name) => {
        return values?.[name] && formErrors?.[name].every(item => !item.status)
    }

    const validateInputs = useCallback((e, name, oldValue) => {
        const value = e.target.value
        const errors = []
        passwordErrors[name].forEach((item) => {
            errors.push({
                status: !item.validator(value, oldValue),
                message: item.message
            })
        })
        setFormErrors(prev => ({
            ...prev,
            [name]: errors
        }))
    }, [])

    const getButtonStatus = (values) => {
        return !checkIsValid(values, names.previous_password) ||
            !checkIsValid(values, names.proposed_password) ||
            !checkIsValid(values, names.confirm_new_password) ||
            showLoader
    }

    return (
        <main className={classNames('main settings', {
            dark: isDarkMode
        })}>
            <div>
                <ResponsivePageTitle/>
                <div className="content-title">
                    <div className="left-side">
                        <div>
                            <PageSubTitle>
                                <p className={classNames('section', {
                                    dark: isDarkMode
                                })}>{text.section}</p>
                            </PageSubTitle>
                            <PageTitle>
                                <h1  className={classNames('page-title', {
                                    dark: isDarkMode
                                })}>{text.title}</h1>
                            </PageTitle>
                        </div>
                    </div>
                </div>
                <div className="content-body">
                    <Formik
                        initialValues={initialFormValues}
                        onSubmit={updateCustomerPassword}
                        validateOnBlur={false}
                        validateOnChange={true}>
                        {({
                            values, errors, touched, handleChange, handleSubmit, setFieldTouched, setTouched
                        }) => (
                            <form onSubmit={handleSubmit} className="form-elements">
                                <div className="input-container">
                                    <Input
                                        type="password"
                                        value={values.previous_password}
                                        placeholder={text.previous_password}
                                        infoText={text.previous_password_info}
                                        name={names.previous_password}
                                        onChange={e => {
                                            validateInputs(e, names.previous_password)
                                            handleChange(e)
                                        }}
                                        onFocus={() => {
                                            setFieldTouched(names.previous_password)
                                        }}
                                        onBlur={() => setTouched({})}
                                        error={errors.previous_password}
                                        activeInfo={active === names.previous_password}
                                        handleInfo={(state) => handleInfo(names.previous_password, state)}
                                        isTouched={touched.previous_password}
                                        isCheckedPass
                                        icon={checkIsValid(values, names.previous_password)}
                                        hasRealTimeValidation={true}
                                    />
                                    {Forms.getValidationToolTip(checkIsValid, values, names.previous_password, formErrors, touched, text.password_requirments, isDarkMode)}
                                </div>
                                <div className="input-container">
                                    <Input
                                        type="password"
                                        value={values.proposed_password}
                                        placeholder={text.new_password}
                                        infoText={text.new_password_info}
                                        name={names.proposed_password}
                                        onChange={e => {
                                            validateInputs(e, names.proposed_password)
                                            handleChange(e)
                                        }}
                                        onFocus={() => {
                                            setFieldTouched(names.proposed_password)
                                        }}
                                        onBlur={() => setTouched({})}
                                        error={errors.proposed_password}
                                        activeInfo={active === names.proposed_password}
                                        handleInfo={(state) => handleInfo(names.proposed_password, state)}
                                        isTouched={touched.proposed_password}
                                        isCheckedPass
                                        icon={checkIsValid(values, names.proposed_password)}
                                        hasRealTimeValidation={true}
                                    />
                                    {Forms.getValidationToolTip(checkIsValid, values, names.proposed_password, formErrors, touched, text.password_requirments, isDarkMode)}
                                </div>
                                <div className="input-container">
                                    <Input
                                        type="password"
                                        placeholder={text.confirm_new_password}
                                        infoText={text.confirm_new_password_info}
                                        name={names.confirm_new_password}
                                        onChange={e => {
                                            validateInputs(e, names.confirm_new_password, values.proposed_password)
                                            handleChange(e)
                                        }}
                                        onFocus={() => {
                                            setFieldTouched(names.confirm_new_password)
                                        }}
                                        onBlur={() => setTouched({})}
                                        error={errors.confirm_new_password}
                                        activeInfo={active === names.confirm_new_password}
                                        handleInfo={(state) => handleInfo(names.confirm_new_password, state)}
                                        isTouched={touched.confirm_new_password}
                                        isCheckedPass
                                        icon={checkIsValid(values, names.confirm_new_password)}
                                        hasRealTimeValidation={true}
                                    />
                                    {Forms.getValidationToolTip(checkIsValid, values, names.confirm_new_password, formErrors, touched, text.password_requirments, isDarkMode)}
                                </div>
                                <SimpleBlueButton
                                    disabled={getButtonStatus(values)}
                                    type="submit">
                                    {showLoader && <ButtonLoader/>}
                                    {text.update_password}
                                </SimpleBlueButton>
                            </form>
                        )}
                    </Formik>
                </div>
            </div>
            <Footer/>
        </main>
    )
}

export default ChangePassword
